import { createSlice, configureStore } from "@reduxjs/toolkit";
import { createPlayerObj } from "../../gaming_components/LoadGame/LoadGame";
import {
    serify,    
    defaultOptions,
} from '@karmaniverous/serify-deserify';
const initialState = {
    socket_connected: false,
    solo_id: "myself",
    multiplayer_id: "",
    gamePage: false,
    notStart: true, // flag for multiplayer game input
    countdownFlag: false,
    countdown: -1,
    gameData: {},
    room: {
        gameType: "NONE", // states = ["MULTIPLAYER", "PRACTICE", "PRIVATE"]
        players: {}
    },
    race_stats: {
        incorrectWords:{},
        wordsOverTime:{},
        liveWPMData: [] // Array of {t: secondsFromStart, wpm: number} for rolling window WPM
    },
    multiplayer_wpm: 0,
    multiplayer_races_count: 0,
    practice_WPM: 0,
    practice_races_count: 0,
    practiceRoomTimers:{
        countdown: 10,
        gameplay: 60
    },
    showLoader: false,
    practiceCountdownStartTime: null, // Timestamp when practice countdown starts
    practiceGameStartTime: null, // Timestamp when practice game starts
    practiceGameInitialTime: null, // Initial estimatedTime when practice game starts
    toast: {
        message: null,
        type: null, // 'error' | 'success' | 'warning'
        id: null
    },
    isJoiningRoom: false,
    isLeavingRoom: false
}
const gameSlice = createSlice({
    name: 'game',
    initialState,
    reducers: {
        toggleGame(state){
            state.gamePage = !state.gamePage;
        },
        setPlayerID(state,action){
            state.multiplayer_id = action.payload.socket_id;
        },
        setSocketConnection(state){
            state.socket_connected = true;
        },
        setGameData(state,action){
            state.gameData = action.payload.gameData;
        },
        setRoomPlayers(state,action){
            if (action.payload.multiplayer === false){
                state.room.players[state.solo_id] = action.payload.playerObj;
            }            
        },
        addPlayerToRoom(state,action) {             
            state.room.players[action.payload.player_id] = createPlayerObj(action.payload.player_id);
        },
        deletePlayerFromRoom(state,action){
            const playerToDelete = action.payload.delete_player;
            console.log(state.room.players[playerToDelete]);
            if(state.room.players[playerToDelete]){
                delete state.room.players[playerToDelete];
            }
        },
        setRaceState(state,action){
            state.race_stats = action.payload.raceObj;
        },        
        setRoomType(state,action) {
            const gameType_ = action.payload.gameType;
            if(
                gameType_ === "NONE" || 
                gameType_ === "MULTIPLAYER" || 
                gameType_ === "PRACTICE" || 
                gameType_ === "PRIVATE"
            ){
                state.room.gameType = action.payload.gameType;
            }
            else{
                throw Error("Dispatched action with wrong Game Type");
            }            
        },
        setRoomStartTime(state) {
            state.room["mStartTime"] = serify(new Date(),defaultOptions);
        },
        updatePlayerWord(state,action) {            
            state.room.players[action.payload.player_id]["currentWord"] = action.payload.currWord;
        },
        updatePlayerWPM(state,action){                                        
            state.room.players[action.payload.player_id]["wpm"] = action.payload.wpm;
        },
        updateGameStatus(state,action){
            state.room.players[action.payload.player_id]["gameEnd"] = !state.room.players[action.payload.player_id]["gameEnd"];
        },
        resetGameStatus(state){
            state.room.players = {};
        },
        setCountDown(state, action){
            state.countdown = action.payload.second;
        },
        toggleNotStart(state){
            state.notStart = !state.notStart;
        },
        setNotStart(state,action){
            const {newState} = action.payload;
            state.notStart = newState;
        },
        startCountDown(state){
            state.countdownFlag = true;
            state.countdown = -1;
        },
        toggleCountDown(state){
            state.countdownFlag = !state.countdownFlag;
        },
        setCountDownState(state,action){
            const { newState } = action.payload;
            state.countdownFlag = newState;
        },
        updateEstimatedTime(state){
            state.gameData.estimatedTime-=1;
        },
        endAllPlayerGames(state){
            for(let player in state.room.players){
                if(state.room.players[player].gameEnd !== true){
                    state.room.players[player].gameEnd = true;
                }
            }
        },
        updatePlayerPosition(state,action){
            const {player_id, win_position} = action.payload;
            state.room.players[player_id]["position"] = win_position;            
        },
        resetGameState(state){
            state.notStart = true;
            state.countdownFlag = false;
            state.countdown = -1;
            state.room = {
                gameType: "NONE",
                players: {}
            };
            state.race_stats = {
                incorrectWords:{},
                wordsOverTime:{},
                liveWPMData: []
            };
            state.practiceCountdownStartTime = null;
            state.practiceGameStartTime = null;
            state.practiceGameInitialTime = null;
        },
        resetGameStateForTransition(state){
            // Preserve room.gameType during transitions to prevent loader from showing
            // This is used when transitioning between games of the same type
            const currentGameType = state.room.gameType;
            
            state.notStart = true;
            state.countdownFlag = false;
            state.countdown = -1;
            state.room = {
                gameType: currentGameType, // Preserve the game type
                players: {}
            };
            state.race_stats = {
                incorrectWords:{},
                wordsOverTime:{},
                liveWPMData: []
            };
            state.practiceCountdownStartTime = null;
            state.practiceGameStartTime = null;
            state.practiceGameInitialTime = null;
        },
        resetRaceStats(state){
            state.race_stats = {
                incorrectWords:{},
                wordsOverTime:{},
                liveWPMData: []
            }
        },
        setGamePlayTimer(state,action){
            state.practiceRoomTimers.gameplay = action.payload;
        },
        resetPracticeTimers(state){
            state.practiceRoomTimers.countdown = 10;
            state.practiceRoomTimers.gameplay = 60;
        },
        toggleLoader(state){
            state.showLoader = !state.showLoader;
        },
        setPracticeWPM(state,action){
            state.practice_races_count+=1
            if (state.practice_races_count === 1){
                state.practice_WPM = action.payload;
            }
            else{
                state.practice_WPM += (action.payload - state.practice_WPM)/state.practice_races_count;
            }            
        },
        setMultiplayerWPM(state,action){
            state.multiplayer_races_count+=1
            if(state.multiplayer_races_count === 1){
                state.multiplayer_wpm = action.payload;
            }
            else{
                state.multiplayer_wpm += (action.payload - state.multiplayer_wpm)/state.multiplayer_races_count;
            }
        },
        setProgressRaceStatistic(state,action){
            const { word, secondTyped, wordWPM } = action.payload;
            if(!(word in state.race_stats.wordsOverTime)){
                state.race_stats.wordsOverTime[word] = [secondTyped,wordWPM];
            }
        },
        setIncorrectRaceStatistic(state,action){
            const {word, incorrectChar, timestamp,wpm} = action.payload;
            if(!(word in state.race_stats.incorrectWords)){
                state.race_stats.incorrectWords[word] = [[incorrectChar,timestamp,wpm]];
            }else{
                state.race_stats.incorrectWords[word] = [...state.race_stats.incorrectWords[word],[incorrectChar,timestamp,wpm]];
            }            
        },
        addLiveWPMDatapoint(state,action){
            const { timestamp, wpm } = action.payload;
            state.race_stats.liveWPMData.push({ t: timestamp, wpm });
            // Keep only last 1000 points to prevent memory bloat
            if (state.race_stats.liveWPMData.length > 1000) {
                state.race_stats.liveWPMData.shift();
            }
        },
        showToast(state,action){
            const {message, type = 'error'} = action.payload;
            state.toast = {
                message,
                type,
                id: Date.now() // Use timestamp as unique ID
            };
        },
        clearToast(state){
            state.toast = {
                message: null,
                type: null,
                id: null
            };
        },
        setIsJoiningRoom(state,action){
            state.isJoiningRoom = action.payload.isJoining;
        },
        setIsLeavingRoom(state,action){
            state.isLeavingRoom = action.payload.isLeaving;
        },
        setPracticeCountdownStartTime(state,action){
            state.practiceCountdownStartTime = action.payload.timestamp;
        },
        clearPracticeCountdownStartTime(state){
            state.practiceCountdownStartTime = null;
        },
        setPracticeGameStartTime(state,action){
            state.practiceGameStartTime = action.payload.timestamp;
            state.practiceGameInitialTime = action.payload.initialTime;
        },
        clearPracticeGameStartTime(state){
            state.practiceGameStartTime = null;
            state.practiceGameInitialTime = null;
        }
    }
});
const store = configureStore({
    reducer: {
        game: gameSlice.reducer
    }
});
export const { 
    toggleGame,
    setPlayerID,
    setGameData, 
    setRoomPlayers, 
    addPlayerToRoom,
    deletePlayerFromRoom,
    setRaceState, 
    setRoomType,
    setRoomStartTime,
    updatePlayerWord,
    updatePlayerWPM,
    updateGameStatus,
    resetGameStatus,
    setCountDown,
    toggleNotStart,
    setNotStart,
    startCountDown,
    toggleCountDown,
    setCountDownState,
    updateEstimatedTime,
    endAllPlayerGames,
    updatePlayerPosition,
    resetGameState,
    resetGameStateForTransition,
    setGamePlayTimer,
    resetPracticeTimers,
    toggleLoader,
    setSocketConnection,
    setPracticeWPM,
    setMultiplayerWPM,
    setProgressRaceStatistic,
    setIncorrectRaceStatistic,
    resetRaceStats,
    showToast,
    clearToast,
    setIsJoiningRoom,
    setIsLeavingRoom,
    setPracticeCountdownStartTime,
    clearPracticeCountdownStartTime,
    setPracticeGameStartTime,
    clearPracticeGameStartTime,
    addLiveWPMDatapoint
} = gameSlice.actions;
export { gameSlice }; // Export slice for testing
export default store;
